module.exports = __webpack_public_path__ + "img/teletravail_coach.d1e09a16.jpg";